import React, { useCallback, useState } from "react";
import { Grid, Stack, Typography, useScrollTrigger } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import DateRangeFilterButton from "./DateRangeFilterButton";
import { useResponsive } from "../../../../../hooks/useResponsive";
import { DownloadMissingStatus } from "./DownloadMissingStatus";
import ToggleInput from "../../../../../components/ToggleInput";
import Team from "../../../../myTask/components/Filters/Team";
import { useTeams } from "../../../../../utils/reactQuery/teams";
import { setAllGroupUser } from "../../../../../redux/TaskGroupingSlice";

const Header = React.memo(() => {
  const dispatch = useDispatch();
  const isMobile = useResponsive("down", "md");
  const trigger = useScrollTrigger();
  const [isVisible, setIsVisible] = useState(false);
  const { teams } = useTeams();

  const groupingUser = useSelector(
    (state) => state.groupingUser.allocationUsers
  );

  const clearFilters = useCallback(() => {
    dispatch(setAllGroupUser([]));
  }, [dispatch]);

  return (
    <>
      {isMobile ? (
        <Grid
          container
          xs={12}
          className="remove-container-width fixed-ui"
          sx={{ top: trigger ? "0px" : isMobile ? "51px" : "" }}
          justifyContent={"center"}
          boxShadow={" 0px 1px 7px rgba(0, 0, 0, 0.3)"}
          pb={"16px !important"}
          pt={trigger ? "16px !important" : "20px !important"}
          alignItems={"center"}
        >
          <Grid
            item
            xs={4}
            md={12}
            lg={3}
            className="d-flex align-items-center"
          >
            <Typography fontWeight={600}>Missing Status Reports</Typography>
          </Grid>
          <Grid item xs={8} md={7} lg={9}>
            <Stack direction="row" justifyContent="end">
              <DateRangeFilterButton />
              <DownloadMissingStatus />
            </Stack>{" "}
          </Grid>
        </Grid>
      ) : (
        <React.Fragment>
          <p className="report-header-name">Missing Status Reports</p>
          <div className="report-header mt-4">
            <div className="d-flex align-items-center">
              <ToggleInput
                value={isVisible}
                setValue={(value) => {
                  setIsVisible(value);
                  if (!value) {
                    clearFilters();
                  }
                }}
              />
              <div className={`slide-panel d-flex ${isVisible ? "open" : ""}`}>
                <Team
                  user={groupingUser.map((item) => item.users).flat()}
                  team={teams}
                />
              </div>
            </div>
            <div className="date-filter">
              <DateRangeFilterButton />
              <DownloadMissingStatus />
            </div>
          </div>
        </React.Fragment>
      )}
    </>
  );
});

export default Header;
